import { DateiArt } from './dateiart.model';
import { DateiArtDetail } from './dateiartdetail.model';
export class DateiArtDetails {
  BILD: Array<DateiArtDetail> = [
    {
      extensions: [ "gif" ],
      mimetypes: [ "image/gif" ],
      icon: "assets/fileicons/gif.png"
    },
    {
      extensions: [ "jpg", "jpeg" ],
      mimetypes: [ "image/jpeg" ],
      icon: "assets/fileicons/jpg.png"
    },
    {
      extensions: [ "png" ],
      mimetypes: [ "image/png" ],
      icon: "assets/fileicons/png.png"
    }
  ];
  VIDEO: Array<DateiArtDetail> = [
/*
    {
      extensions: [ "mpg", "mpeg" ],
      mimetypes: [ "video/mpeg" ],
      icon: "assets/fileicons/mpeg.png"
    },
    {
      extensions: [ "avi" ],
      mimetypes: [ "video/x-msvideo", "video/avi", "video/msvideo" ],
      icon: "assets/fileicons/avi.png"
    },
    {
      extensions: [ "wmv" ],
      mimetypes: [ "video/x-ms-wmv" ],
      icon: "assets/fileicons/wmv.png"
    },
    {
      extensions: [ "mkv" ],
      mimetypes: [ "video/x-matroska" ],
      icon: "assets/fileicons/mkv.png"
    },
*/
    {
      extensions: [ "mp4" ],
      mimetypes: [ "video/mp4" ],
      icon: "assets/fileicons/mp4.png"
    },
    {
      extensions: [ "mov" ],
      mimetypes: [ "video/quicktime" ],
      icon: "assets/fileicons/mov.png"
    }
  ];
  DOKUMENT: Array<DateiArtDetail> = [
    {
      extensions: [ "pdf" ],
      mimetypes: [ "application/pdf" ],
      icon: "assets/fileicons/pdf.png"
    },
    {
      extensions: [ "doc" ],
      mimetypes: [ "application/msword" ],
      icon: "assets/fileicons/doc.png"
    },
    {
      extensions: [ "docx" ],
      mimetypes: [ "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ],
      icon: "assets/fileicons/docx.png"
    },
    {
      extensions: [ "xls" ],
      mimetypes: [ "application/excel", "application/vnd.ms-excel", "application/x-excel", "application/x-msexcel", "" ],
      icon: "assets/fileicons/xls.png"
    },
    {
      extensions: [ "xlsx" ],
      mimetypes: [ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ],
      icon: "assets/fileicons/xlsx.png"
    },
    {
      extensions: [ "ppt" ],
      mimetypes: [ "application/mspowerpoint", "application/vnd.ms-powerpoint", "application/x-mspowerpoint", "application/powerpoint", "" ],
      icon: "assets/fileicons/ppt.png"
    },
    {
      extensions: [ "pptx" ],
      mimetypes: [ "application/vnd.openxmlformats-officedocument.presentationml.presentation" ],
      icon: "assets/fileicons/pptx.png"
    },
    {
      extensions: [ "pps" ],
      mimetypes: [ "application/mspowerpoint", "application/vnd.ms-powerpoint" ],
      icon: "assets/fileicons/pps.png"
    },
    {
      extensions: [ "ppsx" ],
      mimetypes: [ "application/vnd.openxmlformats-officedocument.presentationml.slideshow" ],
      icon: "assets/fileicons/ppsx.png"
    },
    {
      extensions: [ "txt" ],
      mimetypes: [ "text/plain" ],
      icon: "assets/fileicons/txt.png"
    }
  ];

  BILDEXTENSIONS: string = "";
  DOKUMENTEXTENSIONS: string = "";
  VIDEOEXTENSIONS: string = "";
  ALLEEXTENSIONS: string = "";

  constructor() {
    for(let i=0; i<this.BILD.length; i++) {
      for(let j=0; j<this.BILD[i].extensions.length; j++) {
        this.BILDEXTENSIONS += (i>0 || j>0 ? ",." : ".") + this.BILD[i].extensions[j];
      }
    }
    for(let i=0; i<this.VIDEO.length; i++) {
      for(let j=0; j<this.VIDEO[i].extensions.length; j++) {
        this.VIDEOEXTENSIONS += (i>0 || j>0 ? ",." : ".") + this.VIDEO[i].extensions[j];
      }
    }
    for(let i=0; i<this.DOKUMENT.length; i++) {
      for(let j=0; j<this.DOKUMENT[i].extensions.length; j++) {
        this.DOKUMENTEXTENSIONS += (i>0 || j>0 ? ",." : ".") + this.DOKUMENT[i].extensions[j];
      }
    }

    this.ALLEEXTENSIONS = this.BILDEXTENSIONS + "," + this.VIDEOEXTENSIONS + "," + this.DOKUMENTEXTENSIONS;
  }
}
